import React from 'react';
import { getAvgRating } from '../../util/EntertainmentUtil';

export const getScoreColor = (score) => {
  if (score < 0.1)
    return {
      stroke: '#94a3b8',
      glow: 'rgba(148, 163, 184, 0.4)',
      text: 'text-slate-400',
    };
  if (score <= 1.5)
    return {
      stroke: '#ef4444',
      glow: 'rgba(239, 68, 68, 0.4)',
      text: 'text-red-500',
    };
  if (score <= 3.0)
    return {
      stroke: '#fb923c',
      glow: 'rgba(251, 146, 60, 0.4)',
      text: 'text-orange-400',
    };
  if (score < 4.0)
    return {
      stroke: '#4ade80',
      glow: 'rgba(74, 222, 128, 0.4)',
      text: 'text-green-400',
    };
  return {
    stroke: '#166534',
    glow: 'rgba(22, 101, 52, 0.4)',
    text: 'text-green-800',
  };
};

export default function RatingProgressBar({ kqRating, questions, value }) {
  let score = 0;

  if (value !== undefined && value !== null) {
    score = parseFloat(value);
  } else if (kqRating && questions) {
    const rawAvg = getAvgRating(kqRating, questions);
    if (rawAvg !== 0) {
      score = Math.abs(rawAvg / 2);
    }
  }

  const normalizedScore = (score / 5) * 100;
  const radius = 50;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset =
    circumference - (normalizedScore / 100) * circumference;

  const colors = getScoreColor(score);

  return (
    <div className="flex flex-col items-center justify-center p-2">
      <div className="relative flex items-center justify-center">
        {/* Glow effect */}
        <div
          className="absolute inset-0 rounded-full blur-2xl animate-pulse"
          style={{ backgroundColor: colors.glow, transform: 'scale(0.85)' }}
        ></div>

        <svg
          className="relative w-44 h-44 transform -rotate-90 drop-shadow-2xl"
          viewBox="0 0 120 120"
        >
          {/* Background circle */}
          <circle
            cx="60"
            cy="60"
            r={radius}
            fill="none"
            stroke="#1e293b"
            strokeWidth="8"
            className="opacity-50"
          />
          {/* Foreground circle */}
          <circle
            cx="60"
            cy="60"
            r={radius}
            fill="none"
            stroke={colors.stroke}
            strokeWidth="8"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap="round"
            className="transition-all duration-1000 ease-out"
            style={{
              filter: `drop-shadow(0 0 6px ${colors.glow})`,
            }}
          />
        </svg>

        {/* Score Text inside Circle */}
        <div className="absolute flex flex-col items-center justify-center mt-1">
          <span
            className="text-5xl font-black text-white tracking-tighter"
            style={{ textShadow: `0 0 20px ${colors.glow}` }}
          >
            {score.toFixed(1)}
          </span>
          <span className="text-[10px] font-bold text-slate-400 mt-1 tracking-[0.2em] uppercase">
            Out of 5
          </span>
        </div>
      </div>
    </div>
  );
}
